import { entitlementsApi } from '@/model/entitlements/api.generated';

export const ENTITLEMENTS_TAG = 'entitlements' as const;

export function registerEntitlementsTags(): void {
  entitlementsApi.enhanceEndpoints({
    endpoints: {
      getApiWorkspacesByIdEntitlements: {
        providesTags: ['workspaces', ENTITLEMENTS_TAG],
      },
    },
  });
}
